import API from "./API";

export default class OrdensTrabalho extends API
{
    static async search(params) {
        return super.get("api/admin/ordens-trabalho/search", params);
    }

    static async all(params) {
        return super.get("api/admin/ordens-trabalho/get-all", {params: params});
    }

    static async get(id) {
        return super.get("api/admin/ordens-trabalho/" + id);
    }

    static async create(params) {
        return super.post("api/admin/ordens-trabalho", params);
    }

    static async update(id, params) {
        return super.put("api/admin/ordens-trabalho/" + id, params);
    }

    static async delete(id) {
        return super.delete("api/admin/ordens-trabalho/" + id);
    }
}